
  function openRecentlyViewedPopup(id, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation(); // Thêm cái này để tránh sự kiện nổi lên (bubbling) gây lỗi ở các script khác
    }
        const modal = document.getElementById(id);

    if (modal) {
      modal.style.display = "block";
      document.body.style.overflow = "hidden"; // Chặn cuộn trang nền
    }
  // Đóng modal khi click ra ngoài vùng nội dung
    window.addEventListener('click', function(event) {
      if (event.target == modal) {
        closeRecentlyViewedPopup(id);
      }
    });
    const isRecover = event?.target?.dataset?.recover === "true" ? true : false;
    handleRecoverToggle(event);   
  }
function handleRecoverToggle(event) {
  const trigger = event?.target?.closest('[data-recover]');
  if (!trigger) return;

  const isRecover = trigger.dataset.recover === "true";

  const recoverItem = document.getElementById('rv-recover-item');
  const loginItem   = document.getElementById('rv-login-item');

  if (!recoverItem || !loginItem) return;

  recoverItem.classList.toggle('hidden', !isRecover);
  loginItem.classList.toggle('hidden', isRecover);
}
function closeRecentlyViewedPopup(id) {
  console.log(id);
  const modal = document.getElementById(id);
  if (modal) {
    modal.style.display = "none";
    document.body.style.overflow = ""; // Khôi phục cuộn trang
  }
}

function setEqualHeight(selectorA, selectorB) {
  const elA = document.querySelector(selectorA);
  const elB = document.querySelector(selectorB);

  // 1. Kiểm tra nếu 1 trong 2 không tồn tại thì dừng lại để tránh lỗi
  if (!elA || !elB) return;

  // 2. Reset về 'auto' trước để đo được chiều cao thực tế (quan trọng khi resize)
  elA.style.height = 'auto';
  elB.style.height = 'auto';

  // 3. Lấy chiều cao cao nhất trong 2 thằng
  const maxHeight = Math.max(elA.offsetHeight, elB.offsetHeight);

  // 4. Gán chiều cao đó cho cả 2 (để chúng bằng nhau chằn chặn)
  elA.style.height = `${maxHeight}px`;
  elB.style.height = `${maxHeight}px`;
}

// --- CÁCH SỬ DỤNG ---

function runHeightSync() {
  // if(window.innerWidth > 768){
    if (typeof setEqualHeight === 'function') {
        setEqualHeight('.history-carousel-ounner', '.wishlist-carousel-ounner');
    }
  // }
}

class WCWishlistAcc extends HTMLElement {
  constructor() {
    super();
    this.isInPopup = this.hasAttribute('in-popup');
    this.limitCount = 8; 
  }

  connectedCallback() {
    document.addEventListener('wcWishlist::fetched', () => this.renderWishList.bind(this)());
    document.addEventListener('wcWishlist::itemAdded', () => this.reRenderWishlist.bind(this)(true));
    document.addEventListener('wcWishlist::itemRemoved', () => this.reRenderWishlist.bind(this)(false));

    if (window.wcWishlist && window.wcWishlist.listcontents) {
      this.renderWishList();
    }
  }

  reRenderWishlist(openPopup) {
    const self = this;
    function onSwymLoadCallback(swat) {
      swat.fetchLists({
        callbackFn: async (lists) => {
          window.wcWishlist = lists[0];
          self.renderWishList(openPopup);
        }
      });
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  }

  async renderWishList(openPopup) {
    const self = this;
    if (!window.wcWishlist || !window.wcWishlist.listcontents) return;

    const wishListProducts = window.wcWishlist.listcontents;
    const totalCount = wishListProducts.length;

    this.updateEmptyStatus(totalCount);

    if (totalCount === 0) {
      this.innerHTML = '';
      if (typeof runHeightSync === 'function') runHeightSync();
      this.updateCounters(0);
      return;
    }

    // Cắt danh sách sản phẩm lấy 8 cái
    const limitedProducts = wishListProducts.slice(0, this.limitCount);
    const handles = limitedProducts.map(product => product.du.split('products/')[1]).join(',');

    // Lưu handles vào cart attribute (để server-side có thể dùng nếu cần)
    await this.storeParamsToCart(handles);

    fetch(`/pages/swym-wishlist?view=wishlist&inpopup=true`)
      .then(res => res.text())
      .then(textHTML => {
        self.innerHTML = textHTML;

        const items = self.querySelectorAll('.wc-wishlist-product'); 
        if (items.length > this.limitCount) {
          items.forEach((item, index) => {
            if (index >= this.limitCount) {
              item.style.display = 'none'; // Ẩn các item thừa
            }
          });
        }
        this.updateCounters(totalCount);

        if (openPopup) {
          const ELM_wishlistPopup = document.querySelector('#WCWishlistPopup');
          if (ELM_wishlistPopup && typeof ELM_wishlistPopup.show === 'function') {
            ELM_wishlistPopup.show();
          }
        }

        setTimeout(() => {
          if (typeof runHeightSync === 'function') runHeightSync();
        }, 150);
      })
      .catch(err => console.error("Error rendering wishlist:", err));
  }

  async storeParamsToCart(handles) {
    const attributes = { wl_products: handles };
    if (this.isInPopup) {
      attributes.inpopup = true;
    }
    return fetch(`/cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    }).then(response => response.json());
  }

  updateCounters(count) {
    const ELM_wishlistCounters = document.querySelectorAll('wc-wishlist-counter');
    let value = '';
    const countLabel = parseInt(count) > 1 ? 'Products' : 'Product';
    if (count && count !== 0) {
      value = count + ' ' + countLabel;
    }
    ELM_wishlistCounters?.forEach(elm => elm.innerHTML = value);
  }

  updateEmptyStatus(count) {
    const ELM_wishlistEmpty = document.getElementById('wishlist-empty');
    const ELM_hasWishlist = document.getElementById('has-wc-wishlist');

    if (count > 0) {
      ELM_wishlistEmpty?.classList.add('hidden');
      ELM_hasWishlist?.classList.remove('hidden');
    } else {
      ELM_wishlistEmpty?.classList.remove('hidden');
      ELM_hasWishlist?.classList.add('hidden');
    }
  }
}

if (!customElements.get('wc-wishlist-acc')) {
  customElements.define('wc-wishlist-acc', WCWishlistAcc);
}

const callSynMetafields = async (event, token, storeName) => {
  if (event) {
    event.preventDefault(); 
    event.stopPropagation(); 
  }

  const refreshIcons = document.querySelectorAll('.status-card-icon .refresh-icon');
  const loadingIcons = document.querySelectorAll('.status-card-icon .loading__spinner');
  const url = 'https://middlewareapiuat.citysuper.com.hk/api/user/metafields';
  
  const payload = {
    token: token,
    storeName: storeName
  };

  if (refreshIcons && loadingIcons) {
    refreshIcons.forEach(icon => {
        icon.classList.add('hidden');
    });
    loadingIcons.forEach(icon => {
        icon.classList.remove('hidden');
    });
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(`Success for store ${storeName}:`, data);
    if (refreshIcons && loadingIcons) {
      refreshIcons.forEach(icon => {
          icon.classList.remove('hidden');
          window.location.reload();
      });
      loadingIcons.forEach(icon => {
          icon.classList.add('hidden');
      });
    }    
    return data;

  } catch (error) {
    console.error('Error:', error);
    refreshIcons.forEach(icon => {
        icon.classList.remove('hidden');
    });
    loadingIcons.forEach(icon => {
        icon.classList.add('hidden');
    });
    openRecentlyViewedPopup('popup-refresh', null);
  }
};
function updateSidebarTop() {
    const headerTop = document.querySelector('header');
    const accountSidebar = document.querySelector('.account-sidebar');

    if (headerTop && accountSidebar) {
        // Lấy chiều cao thực tế của header__top
        const headerHeight = headerTop.offsetHeight;
        // Gán giá trị vào thuộc tính top của sidebar
        accountSidebar.style.top = headerHeight + 'px';
    }
}


// Chạy khi web tải xong (để ảnh load hết mới đo đúng)
window.addEventListener('load', runHeightSync);

window.addEventListener('resize', runHeightSync);


document.addEventListener('DOMContentLoaded', () => {
    updateSidebarTop();

    // Cập nhật lại khi resize cửa sổ trình duyệt
    window.addEventListener('resize', updateSidebarTop);

    const logoutBtn = document.getElementById('logout-btn-js');
    if (logoutBtn) {
        logoutBtn.addEventListener('click', function() {
            try {
                localStorage.removeItem('hypertheme:recently-viewed');
            } catch (error) {
                console.error('Error when delete recently-viewed:', error);
            }
        });
    }
    const toggleBtns = document.querySelectorAll('.toggle-password-js');

    // Kiểm tra xem class có tồn tại trong DOM hay không trước khi xử lý
    if (toggleBtns && toggleBtns.length > 0) {
        toggleBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                // Tìm container cha gần nhất để xác định phạm vi xử lý
                const container = this.closest('.custom-input-container');
                
                if (container) {
                    // Tìm các phần tử con tương ứng bên trong container vừa tìm được
                    const passwordInput = container.querySelector('.password-input-js');
                    const eyeShow = container.querySelector('.eye-show-js');
                    const eyeHide = container.querySelector('.eye-hide-js');

                    if (passwordInput) {
                        const isPassword = passwordInput.getAttribute('type') === 'password';
                        passwordInput.setAttribute('type', isPassword ? 'text' : 'password');

                        // Toggle trạng thái hiển thị của các icon SVG
                        if (eyeShow && eyeHide) {
                            if (isPassword) {
                                eyeShow.classList.add('hidden');
                                eyeHide.classList.remove('hidden');
                            } else {
                                eyeShow.classList.remove('hidden');
                                eyeHide.classList.add('hidden');
                            }
                        }
                    }
                }
            });
        });
    }    
});

document.addEventListener('DOMContentLoaded', function () {
  const sourceInput = document.getElementById('customer_email_login');
  const targetInput = document.getElementById('userName');

  if (sourceInput && targetInput) {
    sourceInput.addEventListener('input', function () {
      targetInput.value = this.value;
    });
  }
});